export default "__VITE_ASSET__c8680835__"